import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const updateDevice = async (payload: { body: any; id: number; type: string }) => {
  const { id, body, type } = payload
  const response = await axios.patch(`${getAPIService}/v2/api/ip-devices/${type}/${id}`, body)
  return response.data
}
